import React from 'react';
import { Typography, Tooltip } from '@hpi-sox/hpstellar-core';
import { GearLeaves } from '@hpi-sox/hpstellar-veneer-icons';

import './sustainability-logo.less';

export default ({
    sustainabilityAttribute,
    size = 'large',
    text = 'Engineered for Sustainability',
    style,
    enableTooltip = false,
    toolTipProps = {},
    iconSize = 24,
}) => {
    if (!sustainabilityAttribute || sustainabilityAttribute.toLowerCase() === 'none') {
        return null;
    }

    return (
        <div className={`sustainability-badge ${size}`} style={style}>
            <GearLeaves size={iconSize} color="#5AC68C" />
            <Typography variant={size === 'large' ? 'bodyS' : 'bodyXS'} tag="span" responsive>
                {text}
            </Typography>
            {enableTooltip && (
                <Tooltip
                    className="sustainability-tooltip-button"
                    tooltipClassName="sustainability-tooltip"
                    description={sustainabilityAttribute}
                    position="bottom-start"
                    title={text}
                    {...toolTipProps}
                />
            )}
        </div>
    );
};
